import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

import FilterModal from '../filterModal/filterModal';

import List from './components/List';

import StyledListView from './listView.style';

const ListView = ({ filter }) => (
  <StyledListView>
    <div className="list-view__filter-modal">
      <FilterModal>{filter}</FilterModal>
    </div>

    <motion.div
      className="list-view__grid-wrapper"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4, ease: 'linear', duration: 0.3 }}
    >
      <div className="list-view__grid">
        <div className="list-view__filter">{filter}</div>

        <div className="list-view__list">
          <List />
        </div>
      </div>
    </motion.div>
  </StyledListView>
);

ListView.propTypes = {
  filter: PropTypes.element.isRequired
};

export default ListView;
